import { accent, gold, ocean } from "../colors/brand";

/** Default Canucci brand: gold is the primary action color, ocean teal the secondary. */
export const defaultBrandColors = {
  primary: gold,
  secondary: ocean,
  accent,
};

export const defaultBrandFontFamily = "Instrument Sans, sans-serif";
